export default function parseJSON(str: string) {
  let parsed = str;
  try {
    parsed = JSON.parse(parsed);
  } catch (error) {
    return parsed;
  }
  return parsed;
}
